import { Map } from 'immutable'
import createStore from 'store'
import { appHistory } from 'app/RouterHelpers'

export default createStore(Map(), appHistory)



// WEBPACK FOOTER //
// ./src/scripts/containers/store.js